export enum IntegrationBridgeType {
    ANDROID = 0,
    IOS8 = 1,
    IOS_MODERN = 2,
    HTML5 = 3,
    DUMMY = 4,
    ELECTRON = 5,
    REACT_NATIVE = 6,
}
